import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons/faVolumeUp';

import FormHttpFileBtn from '../../FormHttpFileBtn.jsx';

const BtnAudio = ({
  editor,
  fileUploadUrl,
}) => {
  const [selection, setSelection] = useState(0);

  return (
    <span onClick={() => {
      const { index = 0 } = editor.getSelection() || {};

      setSelection(index);
    }}>
      <FormHttpFileBtn
        onSuccess={(res) => {
          editor.insertEmbed(
            selection,
            'audio',
            res.data.url,
            'user',
          );
        }}
        api={{ url: fileUploadUrl }}
        fileOpts={{ accept: '.mp3' }}
      >
        <FA icon={faVolumeUp} size="xs" />
      </FormHttpFileBtn>
    </span>
  );
};

export default BtnAudio;
